import * as React from "react";
const SvgFiRrPaperPlane = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-paper-plane_svg__a)">
      <path
        fill="#062147"
        d="M23.12.882a2.97 2.97 0 0 0-2.8-.8l-16 3.37a4.995 4.995 0 0 0-2.854 8.481l1.718 1.717a1 1 0 0 1 .293.708v3.168c.002.446.105.885.3 1.285l-.008.007.026.026A3 3 0 0 0 5.157 20.2l.026.026.007-.008c.4.196.84.298 1.285.3h3.168a1 1 0 0 1 .707.292l1.717 1.717a4.96 4.96 0 0 0 5.125 1.21 4.93 4.93 0 0 0 3.344-3.987l3.375-16.035A2.98 2.98 0 0 0 23.12.882M4.6 12.238l-1.719-1.717a2.94 2.94 0 0 1-.722-3.074 2.98 2.98 0 0 1 2.5-2.026L20.5 2.086 5.475 17.113v-2.755a2.98 2.98 0 0 0-.875-2.12m13.971 7.17a3 3 0 0 1-5.089 1.712l-1.72-1.72a2.98 2.98 0 0 0-2.119-.878H6.888L21.915 3.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-paper-plane_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPaperPlane;
